<script>
import { mapActions } from 'vuex'

import mapStoreValue from '@/util/mapStoreValue'

export default {

  computed: {
    invertCameraY: mapStoreValue('invertCameraY', 'setInvertCameraY')
  },

  methods: {

    ...mapActions([
      'resetSettings'
    ]),

    onClearProgression () {
      this.$store.dispatch('resetProgression')
      this.onBack()
    },

    onBack () {
      this.$emit('back')
    }

  }

}
</script>

<template>
  <div class="c-settings">
    <div class="c-settings-content">

      <label class="c-settings-label">

        <div class="c-settings-description">
          Invert camera Y
        </div>

        <div class="c-settings-control">
          <input
            v-model="invertCameraY"
            type="checkbox"
          >
        </div>

      </label>

      <button
        class="c-settings-button"
        @click="onBack"
      >
        Back to menu
      </button>

      <button
        class="c-settings-button"
        @click="resetSettings"
      >
        Reset defaults
      </button>

      <button
        class="c-settings-button"
        @click="onClearProgression"
      >
        Clear progression
      </button>

    </div>
  </div>
</template>

<style lang="scss">

// .c-settings {}

.c-settings-content {
  @include grid;
}

.c-settings-button,
.c-settings-label {
  @include block;
  @include pad-tight;
  @include radius-tight;
  background-color: transparent($white);

  &:hover {
    background-color: translucent($white, 0.1);
  }

}

.c-settings-button {
  @include uppercase;
}

.c-settings-heading {
  @include pad-tight;
  @include strong;
  @include no-push-vertical;
  opacity: 0.4;
}

.c-settings-label {
  @include flex;
  @include flex-center;
}

// .c-settings-description,
// .c-settings-control {}

.c-settings-description {
  @include flex-fixed;
  width: 12em;
}

.c-settings-control {
  @include flex-fluid;
  // width: 6em;
}

</style>
